var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carzRangeSearch" },
    [
      _c("div", { ref: "filter", staticClass: "carzRangeSearchFilterBar" }, [
        _c("div", { staticClass: "carzRangeSearchFilterBar__wrap" }, [
          _c("div", { staticClass: "carzRangeSearchFilterBar__filters" }, [
            _c(
              "div",
              {
                staticClass:
                  "carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap",
              },
              [
                _c(
                  "label",
                  { staticClass: "sr-only", attrs: { for: "make" } },
                  [_vm._v("Make")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    staticClass: "carzRangeSearchFilterBar__select",
                    attrs: { name: "make" },
                    on: {
                      change: function ($event) {
                        return _vm.onMakeChange($event.target.value)
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [_vm._v("Make")]),
                    _vm._v(" "),
                    _vm._l(_vm.filters.makes, function (make) {
                      return _c(
                        "option",
                        { key: make.value, domProps: { value: make.value } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(make.name) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap",
              },
              [
                _c(
                  "label",
                  { staticClass: "sr-only", attrs: { for: "model" } },
                  [_vm._v("Model")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    staticClass: "carzRangeSearchFilterBar__select",
                    attrs: { name: "model", disabled: !_vm.params.make },
                    on: {
                      change: function ($event) {
                        return _vm.onFilterChange("model", $event.target.value)
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [_vm._v("Model")]),
                    _vm._v(" "),
                    _vm._l(_vm.filters.models, function (model) {
                      return _c(
                        "option",
                        { key: model.value, domProps: { value: model.value } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(model.name) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap",
              },
              [
                _c(
                  "label",
                  { staticClass: "sr-only", attrs: { for: "fuel" } },
                  [_vm._v("Fuel")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    staticClass: "carzRangeSearchFilterBar__select",
                    attrs: { name: "fuel" },
                    on: {
                      change: function ($event) {
                        return _vm.onFilterChange("fuel", $event.target.value)
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Fuel type"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filters.fuel, function (fuel) {
                      return _c(
                        "option",
                        { key: fuel.value, domProps: { value: fuel.value } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(fuel.name) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap carzRangeSearchFilterBar__priceBoxWrap",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "carzRangeSearchFilterBar__priceBoxTrigger",
                    attrs: { type: "button" },
                    on: { click: _vm.onPriceBoxChange },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.priceRangeContext) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isPriceBoxOpen,
                        expression: "isPriceBoxOpen",
                      },
                    ],
                    staticClass: "carzRangeSearchFilterBar__priceBox",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "carzRangeSearchFilterBar__priceBoxToggle",
                      },
                      _vm._l(_vm.filters.priceTypes, function (type) {
                        return _c(
                          "button",
                          {
                            staticClass:
                              "carzRangeSearchFilterBar__priceBoxButton",
                            class: {
                              "carzRangeSearchFilterBar__priceBoxButton--active":
                                type.value === _vm.params.priceType,
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.onPriceTypeChange(type.value)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(type.name) +
                                "\n                            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "carzRangeSearchFilterBar__priceBoxRange",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "carzRangeSearchFilterBar__priceBoxSelectWrap",
                          },
                          [
                            _c("label", { attrs: { for: "priceFrom" } }, [
                              _vm._v("Price from"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap",
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass:
                                      "carzRangeSearchFilterBar__select",
                                    attrs: { name: "price_from" },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onFilterChange(
                                          "priceFrom",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("Select"),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.priceRangeFrom,
                                      function (price) {
                                        return _c(
                                          "option",
                                          {
                                            key: price.label,
                                            domProps: { value: price.value },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.formatCurrency(
                                                    price.label
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "carzRangeSearchFilterBar__priceBoxSelectWrap",
                          },
                          [
                            _c("label", { attrs: { for: "priceFrom" } }, [
                              _vm._v("Price to"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "carzRangeSearchFilterBar__filterWrap carzRangeSearchFilterBar__selectWrap",
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass:
                                      "carzRangeSearchFilterBar__select",
                                    attrs: { name: "price_to" },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onFilterChange(
                                          "priceTo",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("Select"),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.priceRangeTo, function (price) {
                                      return _c(
                                        "option",
                                        {
                                          key: price.label,
                                          domProps: { value: price.value },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.formatCurrency(price.label)
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      !_vm.loaded
        ? _c(
            "div",
            {
              staticClass:
                "carzRangeSearchPage__vehicleCardsGrid vehicleCardsGrid vehicleCardsGrid--fullWidth vehicleCardsGrid--isGrid",
            },
            _vm._l(_vm.loadingPlaceholders, function (index) {
              return _c("VehicleCardLoading", { key: index })
            }),
            1
          )
        : _vm.vehicles.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "carzRangeSearchPage__vehicleCardsGrid vehicleCardsGrid vehicleCardsGrid--fullWidth vehicleCardsGrid--isGrid",
            },
            _vm._l(_vm.vehicles, function (vehicle) {
              return _c("AutonomyVehicleCard", {
                key: vehicle.id,
                attrs: {
                  vehicle: vehicle,
                  "zero-payment-settings": _vm.zeroPaymentSettings,
                },
              })
            }),
            1
          )
        : _c("div", { staticClass: "carzRangeSearchPage__emptyResults" }, [
            _vm._v(
              "\n        Sorry, we couldn't find any vehicles with those search parameters.\n    "
            ),
          ]),
      _vm._v(" "),
      _c("CarzRangeSearchPagination", {
        staticClass: "carzRangeSearchPage__pagination",
        attrs: {
          page: parseInt(_vm.pagination.page),
          "per-page": _vm.pagination.perPage,
          "total-pages": _vm.pagination.totalPages,
          "total-results": _vm.pagination.totalResults,
        },
        on: { prev: _vm.onDecreasePagination, next: _vm.onIncreasePagination },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }